require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-accelerate-your-learning-with-stacked-modules.json") })
        }
      }, "path---blog-how-to-accelerate-your-learning-with-stacked-modules");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-accelerate-your-learning-with-stacked-modules!./.cache/json/blog-how-to-accelerate-your-learning-with-stacked-modules.json
// module id = 836
// module chunks = 231608221292675